import { getYear } from "date-fns";
import { TFunction } from "i18next";

export const getInvestmentBasicDataTags = (post: any, t: TFunction) => {
  const tags = [];

  if (post?.floor && post?.floors) {
    tags.push({
      label: t("investment_page.floor"),
      value: `${post.floor} ${t("investment_page.of")} ${post.floors}`,
    });
  }

  if (post?.house) {
    tags.push({
      label: t("investment_page.house"),
      value: post.house,
    });
  }

  if (post?.finishDate) {
    tags.push({
      label: t("investment_page.completion"),
      value: getYear(post.finishDate),
    });
  }

  return tags;
};
